import { render, staticRenderFns } from "./CardEndereco.vue?vue&type=template&id=48915e2c&scoped=true&"
import script from "./CardEndereco.vue?vue&type=script&lang=js&"
export * from "./CardEndereco.vue?vue&type=script&lang=js&"
import style0 from "./CardEndereco.vue?vue&type=style&index=0&id=48915e2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48915e2c",
  null
  
)

export default component.exports